module.exports = __webpack_public_path__ + "assets/img/creditCardList.08723893.svg";